import { useAppSelector } from "index";
import type { ApplicationState } from "store/index";
import translations from "../../constants/translations.json";

type Language = keyof typeof translations;

function useTranslations() {
  const { language: requestedLanguage, supportedLangs } = useAppSelector((state: ApplicationState) => state.language);
  const lang: Language = requestedLanguage in translations ? (requestedLanguage as Language) : "en";

  return {
    t: translations[lang],
    lang,
    supportedLangs,
  };
}

export default useTranslations;
